import type { ComponentProps } from "react";
import { cn } from "@/lib/cn";

/** White tile button under the word card (play word, show/hide hints). */
export const CardButton = ({
  className,
  ...props
}: ComponentProps<"button">) => (
  <button
    type="button"
    className={cn(
      "hover:-translate-y-0.5 flex min-h-15 items-center justify-center gap-2 rounded-2xl border border-foreground/15 bg-white px-3 py-3 font-medium text-slate-700 text-sm shadow-[0_8px_18px_rgba(15,23,42,0.06)] transition-all duration-200 hover:border-foreground/25 hover:bg-slate-50 active:translate-y-0",
      className,
    )}
    {...props}
  />
);
